<template>
    <div class="review-assessment">
        <div class="review-assessment__header">
            <div>
                <img src="@/assets/images/expert-panel/assessment.svg" />
            </div>
            <div class="review-assessment__title">
                Оценочный лист
            </div>
        </div>
        <div class="review-assessment__body">
            <div v-for="score of review.reviewScores" :key="score.id">
                <ExpertPanelReviewAssessmentSuperScore
                    v-if="score.scoreType === 1"
                    :score="score"
                    v-model="scores[score.id]"
                    :session="session"
                    :readonly="readonly"
                />
                <ExpertPanelReviewAssessmentSuperCriteria
                    v-else
                    :score="score"
                    v-model="scores[score.id]"
                    :session="session"
                    :readonly="readonly"
                />
            </div>
            <div class="review-assessment__score-wrap">
                Итоговый балл <span class="review-assessment__score">{{ totalScore }}</span>
            </div>
            <ExpertPanelReviewAssessmentSuperComments :session="session" />
            <ExpertPanelReviewAssessmentCommentForm
                v-model="form"
                is-super
                :readonly="readonly"
                completed
                @submit="save"
            />
        </div>
    </div>
</template>

<script>
import ExpertPanelReviewAssessmentSuperCriteria
    from "@/components/expert-panel-new/review/super/ExpertPanelReviewAssessmentSuperCriteria.vue";
import ExpertPanelReviewAssessmentSuperScore
    from "@/components/expert-panel-new/review/super/ExpertPanelReviewAssessmentSuperScore.vue";
import ExpertPanelReviewAssessmentSuperComments
    from "@/components/expert-panel-new/review/super/ExpertPanelReviewAssessmentSuperComments.vue";
import ExpertPanelReviewAssessmentCommentForm
    from "@/components/expert-panel-new/review/ExpertPanelReviewAssessmentCommentForm.vue";
import {SCORE_TYPE_SCORE} from "@/consts/scoreTypes";
import {post} from "@/tools/http";
import getApi from "@/tools/api/examination";

export default {
    name: "ExpertPanelReviewAssessmentSuper",
    components: {
        ExpertPanelReviewAssessmentCommentForm,
        ExpertPanelReviewAssessmentSuperComments,
        ExpertPanelReviewAssessmentSuperScore,
        ExpertPanelReviewAssessmentSuperCriteria,
    },
    props: {
        review: Object,
        session: Object,
        readonly: Boolean,
    },
    data() {
        return {
            scores: {},
            form: {
                comment: '',
                finish: false,
            },
            examinationApi: getApi(),
        };
    },
    computed: {
        totalScore() {
            return Object.values(this.scores).reduce((result, score) => {
                if (typeof score === 'object') {
                    result += Object.values(score).reduce((result, score) => {
                        result += score.score * score.weight;
                        return result;
                    }, 0);
                    return result;
                } else {
                    result += +score;
                }
                return result;
            }, 0);
        },
    },
    methods: {
        getCriteria(reviewScoreId, criteriaId) {
            const reviewScore = this.review.reviewScores.find((reviewScore) => reviewScore.id === reviewScoreId);
            if (reviewScore) {
                const criteria = reviewScore.criterias.find((criteria) => criteria.id === criteriaId);
                if (criteria) {
                    return criteria;
                }
            }
            return {
                weight: 1,
            };
        },
        initScores(session) {
            this.scores = (session.reviewSessionScores || []).reduce((result, reviewSessionScore) => {
                if (reviewSessionScore.scoreType === SCORE_TYPE_SCORE) {
                    result[reviewSessionScore.reviewScoreId] = `${reviewSessionScore.score}`;
                } else {
                    if (result[reviewSessionScore.reviewScoreId] === undefined) {
                        result[reviewSessionScore.reviewScoreId] = {};
                    }
                    result[reviewSessionScore.reviewScoreId][reviewSessionScore.criteriaId] = {
                        score: reviewSessionScore.score,
                        weight: this.getCriteria(reviewSessionScore.reviewScoreId, reviewSessionScore.criteriaId).weight,
                    };
                }
                return result;
            }, {});
            this.form = {
                comment: session.comment,
                finish: false,
            };
        },
        postData() {
            return {
                scores: Object.keys(this.scores).reduce((res, scoreId) => {
                    const score = this.review.reviewScores.find((row) => row.id === +scoreId);
                    if (score) {
                        if (score.scoreType === SCORE_TYPE_SCORE) {
                            res.push({
                                reviewSessionId: this.session.id,
                                reviewScoreId: +scoreId,
                                criteriaId: null,
                                score: +this.scores[scoreId],
                            });
                        } else {
                            Object.keys(this.scores[scoreId]).forEach((row) => {
                                res.push({
                                    reviewSessionId: this.session.id,
                                    reviewScoreId: +scoreId,
                                    criteriaId: +row,
                                    relationId: null,
                                    score: +this.scores[scoreId][+row].score,
                                });
                            });
                        }
                    }
                    return res;
                }, []),
                comment: this.form.comment,
                status: this.form.finish ? 'completed' : 'new',
                isSuper: true,
            };
        },
        async save(send = false) {
            const params = this.postData();
            const res = await this.examinationApi.saveSession(this.review.id, this.session.activitySession.id, params);
            if (res !== null) {
                this.$noty.success('Данные сохранены успешно');
                if (send) {
                    await this.examinationApi.sendResults(this.review.id, true, [this.session.activitySession.id]);
                }
                if (this.form.finish) {
                    this.$router.push({
                        name: 'expert-panel-event',
                        params: {
                            type: 'review',
                            event: this.review.id,
                        },
                    });
                }
            } else {
                this.$noty.error('Ошибка');
            }
        },
    },
    created() {
        this.initScores(this.session);
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.review-assessment {
  font-family: Montserrat, sans-serif;
  box-shadow: 0 rem(2) rem(16) rgba(70, 99, 171, 0.16);
  border-radius: rem(16);
  background: #E1F4E4;
  overflow: hidden;
  &__header {
    display: flex;
    align-items: center;
    gap: rem(10);
    padding: rem(20) rem(40);
  }
  &__title {
    font-weight: 600;
    font-size: rem(20);
    line-height: rem(34);
    color: #2A2626;
  }
  &__body {
    background: #fff;
    padding: rem(32) rem(40);
    display: flex;
    flex-direction: column;
    gap: rem(32);
  }
  &__comment {
    display: flex;
    width: 100%;
    gap: rem(16);
    &-right-column {
      flex: 1;
    }
    &-title {
      font-weight: 600;
      font-size: rem(16);
      line-height: rem(22);
      color: #2A2626;
      margin-bottom: rem(6);
    }
    &-textarea {
      width: 100%;
      background: #F9F9FA;
      border-radius: rem(16);
      border: 0;
      padding: rem(16);
      resize: vertical;
      font-size: rem(16);
    }
    &-buttons {
      display: flex;
      margin-top: rem(24);
      gap: rem(24);
      .rsv-button_color_blue {
        font-family: Montserrat, sans-serif;
        padding: rem(14) rem(32);
        background: #4663AB;
        border-radius: rem(10);
        font-weight: 600;
        font-size: rem(14);
        line-height: rem(20);
        color: #FFFFFF;
      }
    }
    .avatar {
      width: rem(48);
      height: rem(48);
      border-width: 2px;

      :deep(img) {
        width: 100%;
        height: 100%;
        border: solid 2px #fff;
      }
    }
  }
  &__score {
    padding: rem(4) rem(16);
    background: #68C87A;
    border-radius: rem(16);
    font-weight: 600;
    font-size: rem(16);
    line-height: rem(22);
    color: #FFFFFF;
    &-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      gap: rem(24);
      padding: rem(10) rem(40);
      background: #FFFFFF;
      box-shadow: 0 0 rem(16) rgba(70, 99, 171, 0.2);
      border-radius: rem(16);
      font-weight: 500;
      font-size: rem(16);
      line-height: rem(16);
      color: #131614;
    }
  }
}


</style>